<template>
  <div class="Rewards">
    <el-table
      :data="rewardsData"
      header-row-class-name="Rewards-header"
      stripe
    >
      <el-table-column prop="name" label="Name">
        <template slot-scope="scope">
          <Name :name="scope.row.name" :logo="scope.row.logo" :href="scope.row.website"/>
        </template>
      </el-table-column>
      <el-table-column prop="amroi" label="Est. Annual Yield in VSYS" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.amroi.toFixed(2)}} VSYS</div>
        </template>
      </el-table-column>
      <el-table-column prop="amroiUsd" label="Est. Annual Yield in USD" align="center">
        <template slot-scope="scope">
          <div>${{scope.row.amroiUsd.toFixed(4)}} USD</div>
        </template>
      </el-table-column>
      <el-table-column prop="percent" label="Est. Annual Percentage Yield" align="center">
        <template slot-scope="scope">
          <div>{{formatPercent(scope.row.percent, 2)}}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="ipxShow" prop="ipxIncome" label="IPX Annual Reward" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.ipxIncome}}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="homeShow" prop="homeIncome" label="Home Annual Reward" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.homeIncome}}</div>
        </template>
      </el-table-column>
      <el-table-column v-if="bankShow" prop="bankIncome" label="Bank Annual Reward" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.bankIncome}}</div>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
  import Name from '@/components/table/tablecell/Name';
  import { formatPercent } from '@/utils/data_parse';
  import { mapState } from 'vuex';

  export default {
    name: 'reward-list',
    components: { Name },
    props: {
      tokens: Array,
    },
    methods: {
      formatPercent,
    },
    computed: {
      ...mapState('nodes', {
        rewardsData: 'rewards',
      }),
      ipxShow() {
        let show = false;
        this.tokens.map((i) => {
          if (i === 'IPX') {
            show = true;
          }
        });
        return show;
      },
      homeShow() {
        let show = false;
        this.tokens.map((i) => {
          if (i === 'HOME') {
            show = true;
          }
        });
        return show;
      },
      bankShow() {
        let show = false;
        this.tokens.map((i) => {
          if (i === 'BANK') {
            show = true;
          }
        });
        return show;
      },
    },
  };
</script>

<style lang="scss">
  .Rewards {
    // margin-top: 50px;
    // border: 1px solid #FF8837;
    border-radius: 3px;
    .el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #F7F7FA;
    }
    .el-table td, .el-table th.is-leaf {
      border-bottom: none;
      padding: 20px 0;
    }
    .el-table::before {
      height: 0;
    }
    .el-table__body tr:hover>td{
      background-color: rgba(#FF8837, 0.1) !important;
    }
  }

  .el-table tr.Rewards-header th, .el-table tr.Rewards-header tr {
    background-color: #F7F7FA;
    color: #7D7D80;
  }
</style>
